<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('finance.exchangeRatesTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_exchange_rate: 'add_exchange_rate'
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addExchangeRateButton="true"
          :openAddExchangeRateModal="openAddExchangeRateModal"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :columns="columns"
          :showHideColumn="showHideColumn"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.exchange_rate_id"
              >
                <td>{{ r.exchange_rate_id }}</td>
                <td>{{ r.staff_name }}</td>
                <td>${{ r.usd_price }}</td>
                <td>TL{{ r.tl_price }}</td>
                <td>
                  <span
                    v-if="r.active === '1'"
                    style=" padding: 5px;  text-transform: uppercase"
                  >
                    <a
                      style="color: #27ae60"
                      class="disabled"
                    >
                      <i
                        class="fa fa-toggle-on"
                        style="font-size: 20px"
                      ></i>
                    </a>
                  </span>
                  <span
                    v-else-if="$_has_perm('add_exchange_rate')"
                    style="padding: 5px; text-transform: uppercase"
                  >
                    <a
                      @click="activeExchangeRate(r.exchange_rate_id)"
                      style="color: #757575"
                      :tooltip="$t('common.active')"
                    >
                      <i
                        class="fa fa-toggle-off"
                        style="font-size: 20px"
                      ></i>
                    </a>
                  </span>
                </td>
                <td>{{ r.exchange_date }}</td>
                <td
                  v-if="$_has_perm('edit_exchange_rate')"
                  class="icon-gap-5"
                >
                  <a
                    @click="openEditExchangeRateModal(r)"
                    style="color: #3867d6"
                    :tooltip="$t('common.edit')"
                  ><i class="material-icons">edit</i></a>
                </td>
                <td
                  v-if="$_has_perm('delete_exchange_rate')"
                  style="padding-left:0px; padding-right:0px"
                >
                  <a
                    @click="deleteExchangeRate(r.exchange_rate_id)"
                    style="color: #db3958"
                    :tooltip="$t('common.delete')"
                  ><i class="material-icons">delete</i></a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isExchange="true"
            v-if="isMobile"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.exchange_rate_id"
              >
                <td>
                  {{ $t('columns.id') }}: {{ r.exchange_rate_id }} <br />
                  {{ $t('columns.staff') }}: {{ r.staff_name }} &nbsp;
                  <br />
                  <span
                    v-if="r.active === '1'"
                    style=" padding: 5px;  text-transform: uppercase"
                  >
                    <a
                      style="color: #27ae60"
                      class="disabled"
                    >
                      <i
                        class="fa fa-toggle-on"
                        style="font-size: 20px"
                      ></i>
                    </a>
                  </span>
                  <span
                    v-else-if="$_has_perm('add_exchange_rate')"
                    style="padding: 5px; text-transform: uppercase"
                  >
                    <a
                      @click="activeExchangeRate(r.exchange_rate_id)"
                      style="color: #757575"
                      :tooltip="$t('common.active')"
                    >
                      <i
                        class="fa fa-toggle-off"
                        style="font-size: 20px"
                      ></i>
                    </a>
                  </span>
                </td>
                <td>
                  ${{ r.usd_price }} -> tl {{ r.tl_price }} , <br />
                  {{ r.exchange_date }} <br />
                  <a
                    v-if="$_has_perm('edit_exchange_rate')"
                    @click="openEditExchangeRateModal(r)"
                    style="color: #3867d6; display: inline-block;"
                    :tooltip="$t('common.edit')"
                  ><i class="material-icons">edit</i></a>
                  <a
                    v-if="$_has_perm('delete_exchange_rate')"
                    @click="deleteExchangeRate(r.exchange_rate_id)"
                    style="color: #db3958;" class="rtl-pr-15 rtl-float-left"
                    :tooltip="$t('common.delete')"
                  ><i class="material-icons">delete</i></a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <add-exchange-rate
            :openExchangeModal="openExchangeModal"
            :closeAddExchangeRateModal="closeAddExchangeRateModal"
            :successAlert="successAlert"
            :addExchangeRateData="addExchangeRateData"
            :exchangeRate="exchangeRate"
          ></add-exchange-rate>

          <edit-exchange-rate
            :openEditExchangeModal="openEditExchangeModal"
            :closeEditExchangeRateModal="closeEditExchangeRateModal"
            :successAlert="successAlert"
            :errorAlert="errorAlert"
            :editExchangeRateData="editExchangeRateData"
            :editExchangeRate="editExchangeRate"
          ></edit-exchange-rate>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import mobileDatatable from '../mobileDatatable'
import addExchangeRate from './addExchangeRate'
import editExchangeRate from './editExchangeRate'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'mobile-datatable': mobileDatatable,
    'add-exchange-rate': addExchangeRate,
    'edit-exchange-rate': editExchangeRate
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      {
        label: this.$t('columns.id'),
        text: this.$t('columns.id'),
        value: '1',
        sortable: true,
        searchable: true,
        name: 'exchange_rate_id'
      },
      {
        label: this.$t('columns.staffName'),
        text: this.$t('columns.staffName'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'staff_name'
      },
      {
        label: this.$t('columns.usdPrice'),
        text: this.$t('columns.usdPrice'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'usd_price'
      },
      {
        label: this.$t('columns.tlPrice'),
        text: this.$t('columns.tlPrice'),
        value: '4',
        sortable: true,
        searchable: true,
        name: 'tl_price'
      },
      {
        label: this.$t('common.active'),
        text: this.$t('common.active'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'active'
      },
      {
        label: this.$t('columns.exchangeDate'),
        text: this.$t('columns.exchangeDate'),
        value: '6',
        sortable: true,
        searchable: true,
        name: 'exchange_date'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      url: 'api/exchange_rate',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      successAlert: false,
      errorAlert: false,
      openExchangeModal: false,
      openEditExchangeModal: false,
      btnsave: true,
      exchangeRateID: [],
      queryParameter: true,
      prevSearchQuery: '',
      apiResults: [],
      theExchangeRateID: '',
      addExchangeRateData: {
        usd_price: '',
        tl_price: ''
      },
      editExchangeRateData: {
        usd_price: '',
        tl_price: ''
      },
      columns: columns,
      sortKey: 'exchange_rate_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'exchange_rate_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    sendToExport() {
      let arr = ''

      for (let i = 0; i < this.exchangeRateID.length; i++) {
        if (i < this.exchangeRateID.length - 1) {
          arr = arr.concat('arr[]=' + this.exchangeRateID[i] + '&')
        } else {
          arr = arr.concat('arr[]=' + this.exchangeRateID[i])
        }
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/exchange-rate-export?' + arr)
    },

    openAddExchangeRateModal() {
      this.openExchangeModal = true
    },

    closeAddExchangeRateModal() {
      this.openExchangeModal = false
      this.successAlert = false
    },

    clearAddExchangeRateModal() {
      this.addExchangeRateData.tl_price = ''
      this.addExchangeRateData.usd_price = ''
    },

    exchangeRate() {
      let token = localStorage.getItem('access_token')

      axios
        .post(this.url, this.addExchangeRateData, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.successAlert = true
          this.clearAddExchangeRateModal()
          this.getResults()
        })
    },

    openEditExchangeRateModal(data) {
      this.theExchangeRateID = data.exchange_rate_id
      this.editExchangeRateData.usd_price = data.usd_price
      this.editExchangeRateData.tl_price = data.tl_price
      this.openEditExchangeModal = true
    },

    closeEditExchangeRateModal() {
      this.openEditExchangeModal = false
      this.successAlert = false
      this.errorAlert = false
    },

    editExchangeRate() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.url + '/' + this.theExchangeRateID, this.editExchangeRateData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.errorAlert = false
          this.successAlert = true
          this.getResults()
        })
        .catch(() => {
          this.successAlert = false
          this.errorAlert = true
        })
    },

    deleteExchangeRate(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(this.url + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
            .then(response => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal(this.$t('common.warning'), `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    activeExchangeRate(id) {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.url + '/' + id + '/active', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.getResults()
          swal({
            title: this.$t('common.done'),
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
        })
        .catch(error => {
          if (error.response) {
            swal(this.$t('common.warning'), `${error.response.data.message}`, 'error')
          }
        })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.apiResults = data.data
          } else {
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getExchangeRateID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .catch(errors => { console.error(errors) })
    },

    getExchangeRateID(exchangeRate) {
      this.exchangeRateID = []
      for (let i = 0; i < exchangeRate.length; i++) {
        this.exchangeRateID[i] = exchangeRate[i].exchange_rate_id
      }
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'exchange_rate_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'exchange_rate_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/exchangeRate/exchangeRate.vue